export class Education {
  public name: string;
  public degree: string;

  constructor (name: string, degree: string) {
    this.name = name;
    this.degree = degree;
  }

  public static mapFromFirestore(education: any): Education {
    return new Education(
      education.name,
      education.degree
    );
  }

  public mapToFirestore(): any {
    return {
      name: this.name,
      degree: this.degree
    };
  }

  public static mapArrayFromFirestore(educations: any[]): Education[] {
    var educationArray = [];
    educations.forEach((education: any) => {
      educationArray.push(Education.mapFromFirestore(education));
    });
    return educationArray;
  }

  public static mapArrayToFirestore(educations: Education[]): any {
    var educationArray = [];
    educations.forEach((education: Education) => {
      educationArray.push(education.mapToFirestore());
    });
    return educationArray;
  }
}
